import React from "react";
import { Modal, Button } from "react-bootstrap";

const HubbucketDetailModal = ({ show, onHide, hubbucket }) => {
  if (!hubbucket) return null;
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Hub-Bucket Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Bucket Name:</strong> {hubbucket.bucket}
        </p>

        <p>
          <strong>Created Date:</strong>{" "}
          {hubbucket.createdAt && (
            <>{new Date(hubbucket.createdAt).toLocaleDateString()}</>
          )}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default HubbucketDetailModal;
